export { gtagEvent, gtagAddToCartEvent, gtagPurchaseEvent } from './gtagEvent';
